import React from 'react'
import RequestPasswordSetForm from "./components/RequestPasswordSetForm"

export default function UnblockAccountPage() {
    const pathname: string = window.location.pathname

    return(
        <div className="sign-in-page-container">
            <div className="content-of-sign-in-page-container">
                <RequestPasswordSetForm resetPasswordForm={pathname.includes("reset-password") ? true : false} unblockAccount={pathname.includes("unblock-account") ? true : false} />
            </div>
        </div>
    )
}
